import React from "react";

export default function FabPlateau({ children }) {
  return <div className="ui-fab-plateau">{children}</div>;
}
